function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { IconWrapper } from '../IconWrapper';
export var RoundCircleClockIcon = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  return /*#__PURE__*/React.createElement(IconWrapper, props, /*#__PURE__*/React.createElement("svg", _extends({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 9.91165H14.4662L17.5108 6.7781C14.4773 3.7779 9.56583 3.66678 6.53229 6.66698C3.49875 9.6783 3.49875 14.5342 6.53229 17.5455C9.56583 20.5568 14.4773 20.5568 17.5108 17.5455C19.022 16.0565 19.7776 14.3119 19.7776 12.1118H22C22 14.3119 21.0222 17.1677 19.0665 19.1012C15.1662 22.9681 8.83244 22.9681 4.93218 19.1012C1.04303 15.2453 1.00969 8.97825 4.90996 5.12243C8.81022 1.26662 15.0662 1.26662 18.9665 5.12243L22 2V9.91165ZM12.5549 7.55593V12.2785L16.4441 14.5897L15.644 15.9343L10.8881 13.1119V7.55593H12.5549Z",
    fill: "#222"
  })));
});
//# sourceMappingURL=RoundCircleClockIcon.js.map